import css from 'styled-jsx/css';

const style = css`
  .none {
    margin-left: 20px;
  }
`;

export default style;
